import classNames from 'classnames';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

export interface CollapserChevronProps {
  isExpanded: boolean;
  disabled?: boolean;
  name: string;
  onToggleCollapsed: (e: ElementMouseEvent) => void;
}

export default function CollapserChevron({
  disabled,
  isExpanded,
  name,
  onToggleCollapsed,
}: CollapserChevronProps): JSX.Element {
  return (
    <BenchlingIcon
      className={classNames('collapserChevron u-pointer', {disabled})}
      icon={isExpanded ? 'chevron-up' : 'chevron-down'}
      altText={isExpanded ? `Collapse ${name}` : `Expand ${name}`}
      onClick={(e: ElementMouseEvent) => {
        if (!disabled) {
          onToggleCollapsed(e);
        }
      }}
    />
  );
}
